export enum ApiErrorCodes {
  BadRequest = 400,
  Forbidden = 403,
  NotFound = 404,
  InternalServer = 500,
}
